/**
 *
 * @param {string} theme
 * @param {string} lang
 * @param {string} colorPref
 * @return {Object}
 */
export const getMainTheme = (theme, lang, colorPref) => {

    const MainTheme = {
        dark: {
            mainBg: "#191c20",
            secondaryBg: "#1b1e23",
            primaryBg: "#161a1e",
            color: "#c3c5b7",
            secondary: "#eaecef",
            primary: "white",
            hover: "#26282b70",
            active: "#2697ff",
            exitRed: "#a12356",
            mainOrange: "#2697ff",
            mainRed: "#e9106c",
            mainGreen: "#1ce087",
            search: "#161a1e",
            input: "#3f4243",
            textArea: "#44464c",
            dropdown: "#36383C",
            tradeBg: "#1e2026",
            tInputBg: "#2a2d35",
            otcInput: "#0e111a",
            mChart: "#131722",
            orderHover: "#5e6673",
            inActive: '#72747830',
            settingBg: 'rgb(43, 49, 57)',
            g1: '#485563',
            g2: '#29323c',
            portalTarget: '#ffffff80'
        },
        light: {
            mainBg: "#fafafa",
            secondaryBg: "white",
            primaryBg: "white",
            color: "#191c20",
            secondary: "#595e67",
            primary: "#595e67",
            hover: "#00000020",
            active: "#2697ff",
            exitRed: "#a12356",
            mainOrange: "#2697ff",
            mainRed: "#f6465d",
            mainGreen: "#37b88b",
            search: "#b7bdc6",
            input: "#fafafa",
            textArea: "#f1f2f3",
            dropdown: "#707a8a",
            tradeBg: "#ffffff",
            tInputBg: "#f0f1f2",
            otcInput: "#f0f1f2",
            mChart: "wheat",
            orderHover: "#f0f1f2",
            inActive: '#72747830',
            settingBg: '#fafafa',
            g1: '#d7dde8',
            g2: '#ffffff',
            portalTarget: '#00000060'
        }
    };

    try {
        const pref = preferences[colorPref]
        MainTheme[theme] = {...MainTheme[theme], ...pref}
    }
    catch (err) {}

    const chosenTheme = { ...MainTheme[theme] }
    chosenTheme.english = lang === "en"
    return chosenTheme
}

export const preferences = {
    classic: {
        mainGreen: '#1ce087', mainRed: '#f84960' // #33c07b
    },
    fresh: {
        mainGreen: '#0ecb81', mainRed: '#e9106c'
    },
    contrast: {
        mainGreen: '#dd7a2b', mainRed: '#1f8df9'
    }
}


export const availablePreferences = () => {
    const prefs = []
    Object.keys(preferences).forEach(key => {
        prefs.push({
            name: key,
            green: preferences[key].mainGreen,
            red: preferences[key].mainRed
        })
    })
    return prefs
}

export const fadeVariants = {
    out: {
        opacity: 0, transition: { duration: 0.3 }
    },
    in: {
        opacity: 1, transition: { duration: 0.3 }
    }
}

export const getTradeTypeColor = (type) => {
    const typedColors = {
        oco: '#819F82',
        stop: '#9F819E',
        market: '#9F9181',
        limit: '#818F9F',
        pending: '#9F9181',
        success: '#819F82',
        error: '#9F819E',
        canceled: '#9F9181',
        timeout: '#9F819E',
        order: '#819F82',
        admin: '#9F819E',
        withdraw: '#9F9181',
        deposit: '#818F9F',
        otc: '#9F9181',
        buy: '#819F82',
        sell: '#9F819E',
        banking: '#9F819E',
        coining: '#9F819E',
        maker: '#819F82',
        taker: '#9F9181',
        completed: '#819F82',
        increase: '#819F82',
        decrease: '#9F819E',
        rejected: '#9F819E',
        done: '#819F82',
        day: '#9F9181',
        month: '#9F819E',
        week: '#818F9F',
        total: '#819F82'
    }

    return typedColors[type]
}
